import { Classes, Label, Switch } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

export interface BooleanInputProps {
  disabled?: boolean;
  inputTestId?: string;
  label?: string;
  large?: boolean;
  leftText?: string;
  onSetValue: (value: string) => void;
  rightText?: string;
  testId?: string;
  value: string | null;
}

export const BooleanInput: React.VFC<BooleanInputProps> = ({
  disabled,
  inputTestId,
  label,
  large,
  leftText,
  onSetValue,
  rightText,
  testId,
  value,
}) => {
  const checked = value === 'true';
  return (
    <div className="sd-input-boolean" data-testid={testId}>
      <Label>
        {leftText ? (
          <div
            className={classNames('sd-input-boolean__text', {
              [Classes.TEXT_DISABLED]: checked,
            })}
          >
            {leftText}
          </div>
        ) : null}
        <Switch
          checked={checked}
          data-testid={inputTestId}
          disabled={disabled}
          inline
          label={label}
          large={large}
          onChange={() => onSetValue(checked ? 'false' : 'true')}
          tagName="div"
        />
        {rightText ? (
          <div
            className={classNames('sd-input-boolean__text', {
              [Classes.TEXT_DISABLED]: !checked,
            })}
          >
            {rightText}
          </div>
        ) : null}
      </Label>
    </div>
  );
};
